export default __webpack_public_path__ + "static/media/cross_icon_dark_grey.1517cbcb.svg";